const normalizeUnit = (unit) => {
  if (!unit) return null;

  const value = unit.trim().toLowerCase();

  if (value === 'daily') return 'daily';
  if (value === 'weekly') return 'weekly';
  if (['day', 'days', 'day/s'].includes(value)) return 'days';
  if (['hour', 'hours'].includes(value)) return 'hours';

  return null;
};

const buildValidityDesc = (item, labels) => {
  if (!item) return null;

  const unit = normalizeUnit(item.validityUnit);

  if (unit === 'daily') return labels?.validity?.daily;
  if (unit === 'weekly') return labels?.validity?.weekly;

  if (item.validity && unit === 'days') {
    return `${labels?.for} ${item.validity} ${labels?.days}`;
  }

  if (item.validity && unit === 'hours') {
    return `${labels?.for} ${item.validity} ${labels?.hours}`;
  }

  return null;
};

const resolvePriceType = (item) => {
  const unit = normalizeUnit(item?.validityUnit);

  if (unit === 'daily') return 'daily';
  if (unit === 'weekly') return 'weekly';

  return null;
};

const buildRoamingNowCharacteristics = (item, labels) => {
  if (!item?.data) return [];

  return [
    {
      type: 'data',
      title: item.data,
      desc: buildValidityDesc(item, labels),
    },
  ];
};

const buildTravelTalkCharacteristics = (item, labels) => {
  const hasVoice = item?.voice !== null && item?.voice !== undefined;
  const hasSms = item?.sms !== null && item?.sms !== undefined;

  if (!hasVoice && !hasSms) return [];

  return [
    {
      type: 'voice',
      title: [hasVoice ? `${item.voice}'` : null, hasSms ? `${item.sms} SMS` : null].filter(Boolean).join(' & '),
      desc: buildValidityDesc(item, labels),
    },
  ];
};

const toPlan = (item, characteristics) => ({
  title: item.title,
  characteristics,
  price: {
    type: resolvePriceType(item),
    amount: item.price,
  },
});

export const buildMainPlan = (travelPass, labels) => {
  if (!travelPass) return null;

  const desc = buildValidityDesc(travelPass, labels) || labels?.travelPass?.planUsage;

  return {
    title: travelPass.title,
    characteristics: [
      { type: 'data', title: labels?.travelPass?.dataTitle, desc },
      { type: 'voice', title: labels?.travelPass?.voiceTitle, desc },
    ],
    price: {
      type: resolvePriceType(travelPass),
      amount: travelPass.price,
    },
  };
};

export const buildPlans = (roamingNowList, travelTalkList, labels) => [
  ...roamingNowList.map((item) => toPlan(item, buildRoamingNowCharacteristics(item, labels))),
  ...travelTalkList.map((item) => toPlan(item, buildTravelTalkCharacteristics(item, labels))),
];

export const getOuterColClass = (mainPlan, plansLength) => {
  if (mainPlan) return 'col-12 col-xl-8';
  if (plansLength === 1) return 'col-12 col-md-6 col-xl-5';
  if (plansLength === 2) return 'col-12 col-md-8';
  return 'col-12';
};

export const getColClass = (mainPlan, plansLength) => {
  if (mainPlan) return 'col-12 col-md-6';
  if (plansLength === 1) return 'col-12';
  if (plansLength === 2) return 'col-12 col-md-6';
  return 'col-12 col-md-6 col-lg-4';
};
